import * as React from 'react';
import { QuerySingle, useDocumentTitle } from 'gossamer-front-end';
import { Entity, getRowLabel, getTitlePlural, Row } from 'gossamer-unified';

type Verb = 'Create' | 'Delete' | 'Display' | 'Search' | 'Update';

interface PageTitleProps<T extends Row> {
  entity?: Entity<T>;
  keyValue?: string;
  subtitle?: string;
  title?: string;
  verb?: Verb;
}

interface PageTitleInnerProps<T extends Row> extends PageTitleProps<T> {
  row?: T;
}

const PageTitleInner: React.FC<PageTitleInnerProps<any>> = (props) => {
  let title = props.verb || props.title || '';
  if (props.entity) {
    const dynamicText = getRowLabel(props.entity, 'PageTitle', props.row);
    title =
      props.row && props.verb === 'Display'
        ? dynamicText
        : props.row
          ? `${title} ${props.entity.title}: ${dynamicText}`
          : props.verb === 'Create'
            ? `Create a new ${props.entity.title}`
            : props.verb === 'Search'
              ? `Search for ${getTitlePlural(props.entity)}`
              : props.entity.title;
  }
  useDocumentTitle(title);
  return <h3>{title}</h3>;
};

export const PageTitle: React.FC<PageTitleProps<any>> = (props) => {
  if (!props.title && !props.verb) {
    throw new Error(`verb or title must be provided as prop`);
  }
  if (!!props.title && !!props.verb) {
    throw new Error(`verb and title must not both be provided as prop`);
  }
  if (props.keyValue && !props.entity) {
    throw new Error(`if keyValue is provided as prop then so must entity`);
  }
  return (
    <div className="mb20px" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <div style={{ flex: 1 }}>
        {props.entity && props.keyValue ? (
          <QuerySingle
            entity={props.entity}
            keyValue={props.keyValue}
            render={(subprops) => <PageTitleInner {...props} {...subprops} />}
            renderBlank={() => <PageTitleInner {...props} />}
            renderNotFound={() => <PageTitleInner {...props} />}
          />
        ) : (
          <PageTitleInner {...props} />
        )}
        {props.subtitle && <p className="small">{props.subtitle}</p>}
      </div>
    </div>
  );
};
